import { HashOnly } from "./hash";

export type HASH_KEYS = HashOnly.merchant_default | HashOnly.merchant_3;

export type MODE_TYPE = "production" | "staging" | "localnet" | "development";

// 图片、视频等资源访问域名
export const IMAGE_RESOURCE_DOMAIN: { [K in HASH_KEYS]: { [K in MODE_TYPE]: { uri: string; upload: string } } } = {
	[HashOnly.merchant_default]: {
		production: { uri: "https://imagesacc.qlbig05.xyz", upload: "https://imagesacc.qlbig05.xyz" },
		staging: { uri: "https://imagesacc.hfxg.xyz", upload: "https://imagesacc.hfxg.xyz" },
		localnet: { uri: "https://imagesacc.hfxg.xyz", upload: "https://imagesacc.hfxg.xyz" },
		development: { uri: "https://imagesacc.hfxg.xyz", upload: "https://imagesacc.hfxg.xyz" },
	},
	[HashOnly.merchant_3]: {
		production: { uri: "https://images-3-prod.cfeiedu.com", upload: "https://csh5-3-prod.qlbig05.xyz" },
		staging: { uri: "https://images-3-test.qlbig05.xyz", upload: "https://csh5-3-test.qlbig05.xyz" },
		localnet: { uri: "https://imagesacc.hfxg.xyz", upload: "https://imagesacc.hfxg.xyz" },
		development: { uri: "https://imagesacc.hfxg.xyz", upload: "https://imagesacc.hfxg.xyz" },
	},
};
